<nav class="breadcrumb-container py-2" aria-label="Percorso di navigazione"
    style="background-color:#f5f5f5; margin-left:20px;margin-bottom: 15px;padding-left:10px"
    *ngIf="routes.length > 0 && !(routes.length === 1 && routes[0].name === 'Home')">

    <span class="fw-semibold" style="font-size: .8rem;" *ngFor="let route of routes; let isLast=last">
        <!-- Se la breadcrumb non è "edit" o "create" -->
        <ng-container *ngIf="!isLast && route.link !== '' && !isEditOrCreate(route)">
            <a class="me-1" style="text-decoration: none;" [routerLink]="route.link">{{ route.name }}</a>
            <span class="separator me-1"> > </span>
        </ng-container>

        <!-- Se la breadcrumb è "edit" o "create", non la mostriamo -->
        <ng-container *ngIf="!isLast && (route.link === '' || isEditOrCreate(route))">
            <span class="me-1">{{ route.name }}</span>
            <span class="separator me-1"> > </span>
        </ng-container>

        <!-- Ultimo elemento, sempre senza link -->
        <ng-container *ngIf="isLast">
            <span>{{ route.name }}</span>
        </ng-container>
    </span>
</nav>